import { render, staticRenderFns } from "./SubmittedNeedsModal.vue?vue&type=template&id=2dbaf0b8&scoped=true&"
import script from "./SubmittedNeedsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubmittedNeedsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbaf0b8",
  null
  
)

export default component.exports